// --- Traffic Count Filters ---

import z from "zod";
import { CheckboxFilterTypeSchema, MustMatchAllOrMatchNoneSchema } from "../common/common-filter-definitions-schema";
import { MUST_MATCH_ALL_FILTER } from "../common/filter-matchers";

const TrafficCountTypeKeys = [
  "traffic_max_all_motor_vehicles",
  "traffic_max_cars_and_taxis",
  "traffic_max_cars_taxis_lgvs",
  "traffic_max_lgvs",
  "traffic_max_buses_coaches_hgvs",
  "traffic_max_all_hgvs",
] as const;

export const TrafficCountTypeFilterSchema = z
  .object({
    id: z.literal("traffic-count-type-id"),
    type: CheckboxFilterTypeSchema,
    must: MustMatchAllOrMatchNoneSchema,
    values: z.array(
      z.object({
        key: z.enum(TrafficCountTypeKeys),
        checked: z.boolean(),
      }),
    ),
  })
  .describe("Types of vehicle traffic counts available");

export const TrafficCountNumberFilterSchema = z
  .object({
    id: z.literal("traffic-count-number-filter"),
    type: z.literal("number"),
    value: z.number().optional(),
  })
  .describe("Minimum number of vehicles");

export const TrafficCountFilterSchema = z
  .object({
    id: z.literal("traffic-count-id"),
    type: z.literal("compound"),
    must: z.literal(MUST_MATCH_ALL_FILTER),
    filters: z
      .array(z.union([TrafficCountTypeFilterSchema, TrafficCountNumberFilterSchema]))
      .min(2)
      .max(2),
  })
  .describe("Average daily traffic count within 1km for vehicle type and number of vehicles");
